'use strict';

angular.module('app.components').directive('listaSituacoes', listaSituacoesFunc);

listaSituacoesFunc.$inject = ['ConfigApp']

function listaSituacoesFunc(ConfigApp) {
    return {
        require: '^ngModel',
        restrict: 'E',
        scope: {},
        controllerAs: '$ctrl',
        controller: ['$scope', 'categorizacoesApi',
        function ($scope, categorizacoesApi) {

            var $ctrl = this;

            $ctrl.situacoes = [];
            $ctrl.situacao = {};
            $ctrl.ngModel = {};

            $ctrl.$onInit = function () {
                categorizacoesApi.listarSituacoesEncerramento(function (situacoes) {
                    $ctrl.situacoes = situacoes;
                }, function () {
                    $ctrl.situacoes = [];
                })
            }

            $ctrl.setNgModel = function (ngModel) {
                $ctrl.ngModel = ngModel;

                $ctrl.ngModel.$render = $ctrl.definitSituacao;
            }

            $ctrl.definitSituacao = function (situacao) {
                $ctrl.situacao = situacao;
            }

            $ctrl.selecionarSituacao = function (situacao) {
                $ctrl.ngModel.$setViewValue(situacao);

                $ctrl.ngModel.$render(situacao)
            }

        }],
        link: function ($scope, $element, $attr, $ngModelctrl) {
            $scope.$ctrl.setNgModel($ngModelctrl)
        },
        template: require('./situacoes.html')
    }
}



//////////////////
// WEBPACK FOOTER
// ../Projecao.ContactCenter.WebApp.Compartilhado/components/listas/situacoes/index.js
// module id = 315
// module chunks = 1